import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StringSmall, TextMain } from '@components/Typography/Typography';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

import css from './styles.module.scss';

const levelVariants = cva(
  'flex border rounded-[80px] bg-main-bg/60 text-nowrap',
  {
    variants: {
      variant: {
        default: css.level,
        requirenments: css.requirenments,
        grey: css.grey,
      },
      defaultVariant: {
        variant: 'default',
      },
    },
  },
);

interface LevelProps extends VariantProps<typeof levelVariants> {
  className?: string;
  value: number | string;
}

const Level: FC<LevelProps> = ({ value, className, variant }) => {
  const { t } = useTranslation();

  return (
    <div className={cn(levelVariants({ variant }), className)}>
      {variant === 'requirenments' ? (
        <TextMain
          weight="regular"
          className="!text-xs"
        >{`${t('Level')} ${value}`}</TextMain>
      ) : (
        <StringSmall weight="bold">{`${t('Level')} ${value}`}</StringSmall>
      )}
    </div>
  );
};

export { Level };
